// import Select from "react-select";
// import { useState, useEffect } from "react";

// const customStyles = {
//   control: (provided) => ({
//     ...provided,
//     backgroundColor: "#1e293b",
//     borderColor: "#1c2c46",
//     color: "white",
//   }),

//   singleValue: (provided) => ({
//     ...provided,
//     color: "white",
//   }),

//   menu: (provided) => ({
//     ...provided,
//     backgroundColor: "#1e293b",
//   }),

//   option: (provided, state) => ({
//     ...provided,
//     backgroundColor: state.isFocused
//       ? "#3b82f6"
//       : state.isSelected
//       ? "#2563eb"
//       : "#1e293b",
//     color: "white",
//     cursor: "pointer",
//   }),

//   input: (provided) => ({
//     ...provided,
//     color: "white",
//   }),

//   placeholder: (provided) => ({
//     ...provided,
//     color: "#94a3b8",
//   }),
// };

// // Convert HH:MM:SS format to seconds
// const formatToSeconds = (offsetStr) => {
//   if (!offsetStr) return 0;
//   const match = offsetStr.match(/^([+-]?)(\d{2}):(\d{2}):(\d{2})$/);
//   if (!match) return 0;
  
//   const [, sign, hh, mm, ss] = match;
//   const multiplier = sign === "-" ? -1 : 1;
//   const totalSeconds = (Number(hh) * 3600 + Number(mm) * 60 + Number(ss)) * multiplier;
//   return totalSeconds;
// };

// // Convert seconds to HH:MM:SS format with sign
// const secondsToOffsetFormat = (seconds) => {
//   const absSeconds = Math.abs(seconds);
//   const hours = Math.floor(absSeconds / 3600);
//   const minutes = Math.floor((absSeconds % 3600) / 60);
//   const secs = Math.floor(absSeconds % 60);
//   const sign = seconds < 0 ? "-" : "+";
  
//   return `${sign}${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
// };

// // Generate offset options from -36h to +36h in 30-second increments
// const generateOffsetOptions = () => {
//   const options = [];
//   const totalSeconds = 36 * 3600;
  
//   for (let seconds = -totalSeconds; seconds <= totalSeconds; seconds += 30) {
//     const hours = Math.floor(Math.abs(seconds) / 3600);
//     const mins = Math.floor((Math.abs(seconds) % 3600) / 60);
//     const secs = Math.abs(seconds) % 60;
//     const sign = seconds < 0 ? '-' : '+';
    
//     let label;
//     if (hours === 0 && mins === 0 && secs === 0) {
//       label = 'UTC ±0';
//     } else if (mins === 0 && secs === 0) {
//       label = `UTC ${sign}${hours}h`;
//     } else if (secs === 0) {
//       label = `UTC ${sign}${hours}h ${mins}m`;
//     } else {
//       label = `UTC ${sign}${hours}h ${mins}m ${secs}s`;
//     }
    
//     options.push({
//       value: seconds,
//       label: label
//     });
//   }
  
//   return options;
// };

// const OffsetSelect = ({ formData, handleChange, loading }) => {
//   console.log("UserDetails Update With Offset Value:",formData)
//   const offsetOptions = generateOffsetOptions();
//   const [offsetValue, setOffsetValue] = useState(() => {
//     if (formData?.workoffset) {
//       return formatToSeconds(formData.offset);
//     }
//     return 0;
//   });

//   useEffect(() => {
//     if (formData?.workoffset) {
//       const seconds = formatToSeconds(formData.workoffset);
//       setOffsetValue(seconds);
//     }
//   }, [formData?.workoffset]);

//   // Format time parts for display
//   const getTimeParts = (seconds) => {
//     const absSeconds = Math.abs(seconds);
//     const hours = Math.floor(absSeconds / 3600);
//     const minutes = Math.floor((absSeconds % 3600) / 60);
//     const secs = Math.floor(absSeconds % 60);
//     const sign = seconds < 0 ? '-' : '+';
//     return { sign, hours, minutes, secs };
//   };

//   const handleTimeChange = (part, value) => {
//     const parts = getTimeParts(offsetValue);
//     let newHours = parts.hours;
//     let newMinutes = parts.minutes;
//     let newSecs = parts.secs;
//     let newSign = parts.sign;

//     switch(part) {
//       case 'sign':
//         newSign = value;
//         break;
//       case 'hours':
//         newHours = Math.min(36, Math.max(0, parseInt(value) || 0));
//         break;
//       case 'minutes':
//         newMinutes = Math.min(59, Math.max(0, parseInt(value) || 0));
//         break;
//       case 'seconds':
//         newSecs = Math.min(59, Math.max(0, parseInt(value) || 0));
//         break;
//       default:
//         return;
//     }

//     const totalSeconds = (newHours * 3600 + newMinutes * 60 + newSecs) * (newSign === '-' ? -1 : 1);
//     if (Math.abs(totalSeconds) <= 36 * 3600) {
//       setOffsetValue(totalSeconds);
//       const formattedValue = secondsToOffsetFormat(totalSeconds);
//       handleChange({
//         target: {
//           name: "workoffset",
//           value: formattedValue
//         }
//       });
//     }
//   };

//   const handleIncrement = () => {
//     const newValue = offsetValue + 30 * 60;
//     if (newValue <= 36 * 3600) {
//       setOffsetValue(newValue);
//       const formattedValue = secondsToOffsetFormat(newValue);
//       handleChange({
//         target: {
//           name: "workoffset",
//           value: formattedValue
//         }
//       });
//     }
//   };

//   const handleDecrement = () => {
//     const newValue = offsetValue - 30 * 60;
//     if (newValue >= -36 * 3600) {
//       setOffsetValue(newValue);
//       const formattedValue = secondsToOffsetFormat(newValue);
//       handleChange({
//         target: {
//           name: "workoffset",
//           value: formattedValue
//         }
//       });
//     }
//   };

//   const handleSelectChange = (selected) => {
//     if (selected) {
//       setOffsetValue(selected.value);
//       const formattedValue = secondsToOffsetFormat(selected.value);
//       handleChange({
//         target: {
//           name: "workoffset",
//           value: formattedValue
//         }
//       });
//     }
//   };

//   // Format current offset for display
//   const formatCurrentOffset = (seconds) => {
//     const hours = Math.floor(Math.abs(seconds) / 3600);
//     const mins = Math.floor((Math.abs(seconds) % 3600) / 60);
//     const secs = Math.abs(seconds) % 60;
//     const sign = seconds < 0 ? '-' : '+';
    
//     if (hours === 0 && mins === 0 && secs === 0) {
//       return 'UTC ±0';
//     } else if (mins === 0 && secs === 0) {
//       return `UTC ${sign}${hours}h`;
//     } else if (secs === 0) {
//       return `UTC ${sign}${hours}h ${mins}m`;
//     } else {
//       return `UTC ${sign}${hours}h ${mins}m ${secs}s`;
//     }
//   };

//   const currentDisplayValue = offsetOptions.find(o => o.value === offsetValue);
//   const timeParts = getTimeParts(offsetValue);

//   return (
//     <div>
//       <label className="block mb-1 text-sm font-medium text-blue-200">
//         Select Time Offset
//       </label>

//       <div className="flex items-center gap-2">
//         {/* Decrement Button */}
//         <button
//           type="button"
//           onClick={handleDecrement}
//           disabled={loading || offsetValue <= -36 * 3600}
//           className="px-3 py-2 text-white transition-colors bg-red-600 rounded-md hover:bg-red-700 disabled:bg-gray-600"
//         >
//           −
//         </button>

//         {/* Time Input with Sign */}
//         <div className="flex-1 flex gap-1 items-center bg-[#1e293b] border border-[#1c2c46] rounded-md p-1">
//           {/* Sign Selector */}
//           <select
//             value={timeParts.sign}
//             onChange={(e) => handleTimeChange('sign', e.target.value)}
//             disabled={loading || (offsetValue === 0 && timeParts.hours === 0 && timeParts.minutes === 0 && timeParts.secs === 0)}
//             className="w-10 px-1 py-1 text-center text-white bg-transparent border-none outline-none focus:ring-0"
//           >
//             <option value="+">+</option>
//             <option value="-">-</option>
//           </select>

//           <span className="text-white">|</span>

//           {/* Hours */}
//           <input
//             type="number"
//             min="0"
//             max="36"
//             value={String(timeParts.hours).padStart(2, '0')}
//             onChange={(e) => handleTimeChange('hours', e.target.value)}
//             disabled={loading}
//             className="w-12 text-center text-white bg-transparent border-none outline-none focus:ring-0"
//             placeholder="HH"
//           />
//           <span className="text-white">:</span>

//           {/* Minutes */}
//           <input
//             type="number"
//             min="0"
//             max="59"
//             value={String(timeParts.minutes).padStart(2, '0')}
//             onChange={(e) => handleTimeChange('minutes', e.target.value)}
//             disabled={loading}
//             className="w-12 text-center text-white bg-transparent border-none outline-none focus:ring-0"
//             placeholder="MM"
//           />
//           <span className="text-white">:</span>

//           {/* Seconds */}
//           <input
//             type="number"
//             min="0"
//             max="59"
//             value={String(timeParts.secs).padStart(2, '0')}
//             onChange={(e) => handleTimeChange('seconds', e.target.value)}
//             disabled={loading}
//             className="w-12 text-center text-white bg-transparent border-none outline-none focus:ring-0"
//             placeholder="SS"
//           />
//         </div>

//         {/* Increment Button */}
//         <button
//           type="button"
//           onClick={handleIncrement}
//           disabled={loading || offsetValue >= 36 * 3600}
//           className="px-3 py-2 text-white transition-colors bg-green-600 rounded-md hover:bg-green-700 disabled:bg-gray-600"
//         >
//           +
//         </button>
//       </div>

//       {/* Select Dropdown */}
//       <div className="mt-2">
//         <Select
//           options={offsetOptions}
//           value={currentDisplayValue}
//           onChange={handleSelectChange}
//           isDisabled={loading}
//           isSearchable={true}
//           menuPlacement="auto"
//           styles={customStyles}
//           placeholder="Or select from dropdown..."
//         />
//       </div>

//       {/* Display current offset */}
//       <div className="mt-2 text-sm text-blue-300">
//         <div>Current offset: {formatCurrentOffset(offsetValue)}</div>
//         <div className="mt-1 text-xs text-blue-400/70">
//           Backend format: {secondsToOffsetFormat(offsetValue)}
//         </div>
//         <div className="mt-1 text-xs text-gray-400">
//           Sign selector always visible | Hours: 0-36 | Minutes: 0-59 | Seconds: 0-59
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OffsetSelect;


import Select from "react-select";
import { useState, useEffect } from "react";

// ─── Generate offset options ──────────────────────────────────────────────────
const generateOffsetOptions = () => {
  const options = [];
  const totalSeconds = 36 * 3600;
  
  for (let seconds = -totalSeconds; seconds <= totalSeconds; seconds += 30) {
    const hours = Math.floor(Math.abs(seconds) / 3600);
    const mins = Math.floor((Math.abs(seconds) % 3600) / 60);
    const secs = Math.abs(seconds) % 60;
    const sign = seconds < 0 ? '-' : '+';
    
    let label;
    if (hours === 0 && mins === 0 && secs === 0) {
      label = 'UTC ±0';
    } else if (mins === 0 && secs === 0) {
      label = `UTC ${sign}${hours}h`;
    } else if (secs === 0) {
      label = `UTC ${sign}${hours}h ${mins}m`;
    } else {
      label = `UTC ${sign}${hours}h ${mins}m ${secs}s`;
    }
    
    options.push({
      value: seconds,
      label: label
    });
  }
  
  return options;
};

// ─── Helper functions ─────────────────────────────────────────────────────────
const formatToSeconds = (offsetStr) => {
  if (!offsetStr) return 0;
  const match = offsetStr.match(/^([+-]?)(\d{2}):(\d{2}):(\d{2})$/);
  if (!match) return 0;
  
  const [, sign, hh, mm, ss] = match;
  const multiplier = sign === "-" ? -1 : 1;
  const totalSeconds = (Number(hh) * 3600 + Number(mm) * 60 + Number(ss)) * multiplier;
  return totalSeconds;
};

const secondsToOffsetFormat = (seconds) => {
  const absSeconds = Math.abs(seconds);
  const hours = Math.floor(absSeconds / 3600);
  const minutes = Math.floor((absSeconds % 3600) / 60);
  const secs = Math.floor(absSeconds % 60);
  const sign = seconds < 0 ? "-" : "+";
  
  return `${sign}${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
};

// ─── Custom styles for react-select with theme support ──────────────────────
const getSelectStyles = (isDark) => ({
  control: (provided) => ({
    ...provided,
    backgroundColor: isDark ? "#1e293b" : "#ffffff",
    borderColor: isDark ? "#1c2c46" : "#d1d5db",
    color: isDark ? "white" : "#1a1a2e",
    boxShadow: 'none',
    '&:hover': {
      borderColor: isDark ? "#3b82f6" : "#60a5fa",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: isDark ? "white" : "#1a1a2e",
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: isDark ? "#1e293b" : "#ffffff",
    border: `1px solid ${isDark ? "#1c2c46" : "#d1d5db"}`,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? isDark ? "#3b82f6" : "#93c5fd"
      : state.isSelected
      ? isDark ? "#2563eb" : "#60a5fa"
      : isDark ? "#1e293b" : "#ffffff",
    color: isDark ? "white" : "#1a1a2e",
    cursor: "pointer",
    '&:hover': {
      backgroundColor: isDark ? "#3b82f6" : "#93c5fd",
      color: "white",
    },
  }),
  input: (provided) => ({
    ...provided,
    color: isDark ? "white" : "#1a1a2e",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: isDark ? "#94a3b8" : "#6b7280",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: isDark ? "#1c2c46" : "#d1d5db",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: isDark ? "#94a3b8" : "#6b7280",
    '&:hover': {
      color: isDark ? "#ffffff" : "#1a1a2e",
    },
  }),
});

const OffsetSelect = ({ formData, handleChange, loading, theme }) => {
  const isDark = theme === 'dark';
  const offsetOptions = generateOffsetOptions();
  const customStyles = getSelectStyles(isDark);
  
  const [offsetValue, setOffsetValue] = useState(() => {
    if (formData?.workoffset) {
      return formatToSeconds(formData.workoffset);
    }
    return 0;
  });

  useEffect(() => {
    if (formData?.workoffset) {
      const seconds = formatToSeconds(formData.workoffset);
      setOffsetValue(seconds);
    }
  }, [formData?.workoffset]);

  // ─── Theme-aware classes ──────────────────────────────────────────────────
  const bgInput = isDark ? 'bg-[#1e293b]' : 'bg-white';
  const borderColor = isDark ? 'border-[#1c2c46]' : 'border-gray-300';
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  //const textSecondary = isDark ? 'text-blue-300' : 'text-blue-700';
  //const textMuted = isDark ? 'text-blue-400/70' : 'text-gray-500';
  //const textGray = isDark ? 'text-gray-400' : 'text-gray-500';
  const labelColor = isDark ? 'text-blue-200' : 'text-gray-700';
  
  const bgDecrement = isDark ? 'bg-red-600 hover:bg-red-700' : 'bg-red-500 hover:bg-red-600';
  const bgIncrement = isDark ? 'bg-green-600 hover:bg-green-700' : 'bg-green-500 hover:bg-green-600';
  const bgDisabled = isDark ? 'bg-gray-600' : 'bg-gray-300';

  // ─── Time parts ────────────────────────────────────────────────────────────
  const getTimeParts = (seconds) => {
    const absSeconds = Math.abs(seconds);
    const hours = Math.floor(absSeconds / 3600);
    const minutes = Math.floor((absSeconds % 3600) / 60);
    const secs = Math.floor(absSeconds % 60);
    const sign = seconds < 0 ? '-' : '+';
    return { sign, hours, minutes, secs };
  };

  const handleTimeChange = (part, value) => {
    const parts = getTimeParts(offsetValue);
    let newHours = parts.hours;
    let newMinutes = parts.minutes;
    let newSecs = parts.secs;
    let newSign = parts.sign;

    switch(part) {
      case 'sign':
        newSign = value;
        break;
      case 'hours':
        newHours = Math.min(36, Math.max(0, parseInt(value) || 0));
        break;
      case 'minutes':
        newMinutes = Math.min(59, Math.max(0, parseInt(value) || 0));
        break;
      case 'seconds':
        newSecs = Math.min(59, Math.max(0, parseInt(value) || 0));
        break;
      default:
        return;
    }

    const totalSeconds = (newHours * 3600 + newMinutes * 60 + newSecs) * (newSign === '-' ? -1 : 1);
    if (Math.abs(totalSeconds) <= 36 * 3600) {
      setOffsetValue(totalSeconds);
      const formattedValue = secondsToOffsetFormat(totalSeconds);
      handleChange({
        target: {
          name: "workoffset",
          value: formattedValue
        }
      });
    }
  };

  const handleIncrement = () => {
    const newValue = offsetValue + 30 * 60;
    if (newValue <= 36 * 3600) {
      setOffsetValue(newValue);
      const formattedValue = secondsToOffsetFormat(newValue);
      handleChange({
        target: {
          name: "workoffset",
          value: formattedValue
        }
      });
    }
  };

  const handleDecrement = () => {
    const newValue = offsetValue - 30 * 60;
    if (newValue >= -36 * 3600) {
      setOffsetValue(newValue);
      const formattedValue = secondsToOffsetFormat(newValue);
      handleChange({
        target: {
          name: "workoffset",
          value: formattedValue
        }
      });
    }
  };

  const handleSelectChange = (selected) => {
    if (selected) {
      setOffsetValue(selected.value);
      const formattedValue = secondsToOffsetFormat(selected.value);
      handleChange({
        target: {
          name: "workoffset",
          value: formattedValue
        }
      });
    }
  };

  /*const formatCurrentOffset = (seconds) => {
    const hours = Math.floor(Math.abs(seconds) / 3600);
    const mins = Math.floor((Math.abs(seconds) % 3600) / 60);
    const secs = Math.abs(seconds) % 60;
    const sign = seconds < 0 ? '-' : '+';
    
    if (hours === 0 && mins === 0 && secs === 0) {
      return 'UTC ±0';
    } else if (mins === 0 && secs === 0) {
      return `UTC ${sign}${hours}h`;
    } else if (secs === 0) {
      return `UTC ${sign}${hours}h ${mins}m`;
    } else {
      return `UTC ${sign}${hours}h ${mins}m ${secs}s`;
    }
  };*/

  const currentDisplayValue = offsetOptions.find(o => o.value === offsetValue);
  const timeParts = getTimeParts(offsetValue);
  const isZero = offsetValue === 0 && timeParts.hours === 0 && timeParts.minutes === 0 && timeParts.secs === 0;

  return (
    <div>
      <label className={`block mb-1 text-sm font-medium ${labelColor}`}>
        Select Work Offset
      </label>

      <div className="flex items-center gap-2">
        {/* Decrement Button */}
        <button
          type="button"
          onClick={handleDecrement}
          disabled={loading || offsetValue <= -36 * 3600}
          className={`px-3 py-2 ${offsetValue <= -36 * 3600 ? bgDisabled : bgDecrement} text-white rounded-md transition-colors disabled:cursor-not-allowed`}
        >
          −
        </button>

        {/* Time Input with Sign */}
        <div className={`flex-1 flex gap-1 items-center ${bgInput} border ${borderColor} rounded-md p-1 transition-colors duration-300`}>
          {/* Sign Selector */}
          <select
            value={timeParts.sign}
            onChange={(e) => handleTimeChange('sign', e.target.value)}
            disabled={loading || isZero}
            className={`bg-transparent ${textPrimary} border-none focus:ring-0 outline-none px-1 py-1 w-10 text-center`}
          >
            <option value="+">+</option>
            <option value="-">-</option>
          </select>

          <span className={textPrimary}>|</span>

          {/* Hours */}
          <input
            type="number"
            min="0"
            max="36"
            value={String(timeParts.hours).padStart(2, '0')}
            onChange={(e) => handleTimeChange('hours', e.target.value)}
            disabled={loading}
            className={`bg-transparent ${textPrimary} border-none focus:ring-0 outline-none w-12 text-center`}
            placeholder="HH"
          />
          <span className={textPrimary}>:</span>

          {/* Minutes */}
          <input
            type="number"
            min="0"
            max="59"
            value={String(timeParts.minutes).padStart(2, '0')}
            onChange={(e) => handleTimeChange('minutes', e.target.value)}
            disabled={loading}
            className={`bg-transparent ${textPrimary} border-none focus:ring-0 outline-none w-12 text-center`}
            placeholder="MM"
          />
          <span className={textPrimary}>:</span>

          {/* Seconds */}
          <input
            type="number"
            min="0"
            max="59"
            value={String(timeParts.secs).padStart(2, '0')}
            onChange={(e) => handleTimeChange('seconds', e.target.value)}
            disabled={loading}
            className={`bg-transparent ${textPrimary} border-none focus:ring-0 outline-none w-12 text-center`}
            placeholder="SS"
          />
        </div>

        {/* Increment Button */}
        <button
          type="button"
          onClick={handleIncrement}
          disabled={loading || offsetValue >= 36 * 3600}
          className={`px-3 py-2 ${offsetValue >= 36 * 3600 ? bgDisabled : bgIncrement} text-white rounded-md transition-colors disabled:cursor-not-allowed`}
        >
          +
        </button>
      </div>

      {/* Select Dropdown */}
      <div className="mt-2">
        <Select
          options={offsetOptions}
          value={currentDisplayValue}
          onChange={handleSelectChange}
          isDisabled={loading}
          isSearchable={true}
          menuPlacement="auto"
          styles={customStyles}
          placeholder="Or select from dropdown..."
        />
      </div>

      {/* Display current offset */}
      {/* <div className="mt-2 text-sm">
        <div className={textSecondary}>
          Current offset: {formatCurrentOffset(offsetValue)}
        </div>
        <div className={`text-xs ${textMuted} mt-1`}>
          Backend format: {secondsToOffsetFormat(offsetValue)}
        </div>
        <div className={`text-xs ${textGray} mt-1`}>
          Sign selector always visible | Hours: 0-36 | Minutes: 0-59 | Seconds: 0-59
        </div>
      </div> */}
    </div>
  );
};

export default OffsetSelect;
